import styled from 'styled-components'

export default styled.p`
  color: red;
  font-size: 1.4rem;
  font-weight: bold;
  margin: 1rem 0;
  text-align: ${(props) => (props.center ? 'center' : 'inherit')};
`
